import { Link } from "react-router-dom";

export default function QuickLinks() {
  const links = [
    { title: "Jugadores", link: "/my-players", icon: "👤" },
    { title: "Equipos", link: "/my-teams", icon: "👥" },
    { title: "Torneos", link: "/my-tournaments", icon: "🏆" },
  ];

  return (
    <div className="w-full max-w-[400px] mx-auto mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
      {links.map((item) => (
        <Link
          key={item.title}
          to={item.link}
          className="flex flex-col items-center justify-center p-6 bg-gradient-to-r from-purple-600 to-indigo-600 
            text-white font-semibold rounded-3xl shadow-lg hover:scale-105 hover:shadow-2xl transition-all duration-200"
        >
          <span className="text-3xl mb-2">{item.icon}</span>
          <span className="text-sm sm:text-base">{item.title}</span>
        </Link>
      ))}
    </div>
  );
}
